import { FilePath } from 'app/model/dataset/file-path';
import { IModel, IAttribute } from 'app/model/base/annotation';
import { Metamodel } from 'app/model/base/model';

import { Location } from 'app/model/dataset/location/location';
import { OracleCloudStorageLinkedService } from 'app/model/linkedservice/oracle-cloud-storage.linkedservice';
import { stringIsNullOrEmpty } from 'app/shared/utils/string.util';
import { ILocationPath } from 'shell-models-lib';

@Metamodel.model({
    name: 'OracleCloudStorageLocation',
    tags: {
        linkedServiceModel: Metamodel.modelFor(OracleCloudStorageLinkedService)
    }
})
export class OracleCloudStorageLocation extends Location {
    public static readonly MODEL: IModel;
    public static readonly CONTAINER: IAttribute;
    public static readonly FOLDER_PATH: IAttribute;
    public static readonly FILE_NAME: IAttribute;

    @Metamodel.attribute({
        display: stringResources.ModelName_Container,
        association: 'CONTAINER',
        templatable: true
    })
    public container?: string;

    @Metamodel.attribute({
        display: stringResources.FolderPath_Label,
        association: 'FOLDER_PATH',
        templatable: true
    })
    public folderPath?: string;

    @Metamodel.attribute({
        display: stringResources.FileNameLabel,
        association: 'FILE_NAME',
        templatable: true
    })
    public fileName?: string;

    public setLocation(path: FilePath): void {
        this.folderPath = path.folderPath;
        this.fileName = path.fileName;
        this.container = path.container;
    }

    public setParameterizedLocation(path: ILocationPath): void {
        this.setPathPropertyValue('folderPath', OracleCloudStorageLocation.FOLDER_PATH, path);
        this.setPathPropertyValue('fileName', OracleCloudStorageLocation.FILE_NAME, path);
        this.setPathPropertyValue('container', OracleCloudStorageLocation.CONTAINER, path);
    }

    public getLocation(): FilePath {
        const path = new FilePath();
        path.folderPath = this.folderPath;
        path.fileName = this.fileName;
        path.container = this.container;
        return path;
    }

    public getParameterizedLocation(): ILocationPath {
        return {
            folderPath: OracleCloudStorageLocation.FOLDER_PATH.templateValue(this) || this.folderPath,
            fileName: OracleCloudStorageLocation.FILE_NAME.templateValue(this) || this.fileName,
            container: OracleCloudStorageLocation.CONTAINER.templateValue(this) || this.container
        };
    }

    public getFolderPath(): string {
        return this.folderPath;
    }

    public isFolder(fileNameParameterAsFile: boolean = true): boolean {
        return fileNameParameterAsFile && OracleCloudStorageLocation.FILE_NAME.templateValue(this) ? false : !this.fileName;
    }

    public isLocationParameterized(): boolean {
        return !stringIsNullOrEmpty(OracleCloudStorageLocation.CONTAINER.templateValue(this)) ||
            !stringIsNullOrEmpty(OracleCloudStorageLocation.FOLDER_PATH.templateValue(this)) ||
            !stringIsNullOrEmpty(OracleCloudStorageLocation.FILE_NAME.templateValue(this));
    }
}
